
import "./leftBar.scss";
import { AuthContext } from "../../context/authContext";
import { useContext, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { DarkModeContext } from "../../context/darkModeContext";
import { Modal } from "antd";
import PlaceIcon from "@mui/icons-material/Place";
import ScheduleIcon from '@mui/icons-material/Schedule';
import logoutImg from '../../assets/logout.png'
import moment from "moment";
import pages from '../../assets/channel.png'
import groups from '../../assets/reunion.png'
import bookmark from '../../assets/bookmark.png'
import SchoolIcon from '@mui/icons-material/School';
import competiton from '../../assets/advantage.png'
const LeftBar = () => {

  const { toggle, darkMode } = useContext(DarkModeContext);
  const { currentUser, logout } = useContext(AuthContext);
  const location = useLocation();
  const isMessagesPage = location.pathname === '/messages';
  const isProfileOpen = location.pathname === `'/profile'/${currentUser.UUID}` ;
  // const activePath = location.pathname.includes;
  const navigate = useNavigate();
  const [isModalVisible, setIsModalVisible] = useState(false);
  let address = currentUser.city;
  const schoolName = currentUser.schoolName;
  const classGrade = currentUser.className;

 
  function capitalizeFirstLetter(name) {    
    // return name.charAt(0).toUpperCase() + name.slice(1);
  }

  let name = currentUser.name;
  let username = capitalizeFirstLetter(name);

  let lastName = currentUser.lastName;
  let userLastName = capitalizeFirstLetter(lastName);

  console.log(currentUser)

  let email = currentUser.email;
  // let frontPart = email.slice(0, 3);
  // let lastPart = email.slice(-4);
  // let emailWithMask = frontPart + "********" + lastPart;

  const handleLogout = () => {
    logout();
    navigate("/login");
  };
  const handleCancel = () => {
    setIsModalVisible(false);
  };


  return (
    <div className={`leftBar ${isMessagesPage ? "messagePage" : ""}`}>
      <div className="container">
        <div className={`menu ${isMessagesPage ? "messagePage" : ""}`}>
          <div className="user-profile-and-name">
            <Link to={`/profile/${currentUser.UUID}`}>
              <div className="user">
                <img
                  src={currentUser.profilePic}
                  alt=""
                />
              </div>
            </Link>
            <div className={` ${isMessagesPage ? "messagePage" : ""}`}>
              <span style={{ "fontWeight": 600 }} className="username">{username} {userLastName}</span>
              <div className="user-location">
                <PlaceIcon style={{fontSize:"medium"}}/>
                <h5 style={{color:"gray"}}>{address}</h5>
              </div>                          
             
              {/* <p>{emailWithMask}</p> */}
            </div>
              {(schoolName != "null" && schoolName != null) && <div className="user-location">
                <SchoolIcon style={{fontSize:"medium"}}/>
                <h5 style={{color:"gray"}}>{schoolName}</h5>
              </div>}   

              {(classGrade != "null" && classGrade != null ) && <div className="user-location">                
                <h5 style={{color:"gray"}}>In {classGrade} Std.</h5>
              </div>}         
              <div className="user-location">
                {/* <ScheduleIcon/> */}
                <h5 style={{color:"gray"}}>Total Friends : {currentUser.totalFriends}</h5>
              </div>              
              {/* {(isProfileOpen != true) &&<div className="user-location">
                <button className="profile-btn">View Profile</button>
              </div>} */}
              
          </div>      
        </div>
        <div className={`menu ${isMessagesPage ? "messagePage" : ""}`}>
          <div className={`item ${location.pathname.includes("/community") ? "active" : ""}`}>
            <Link to="/community" className={`item-link ${location.pathname.includes("/community") ? "active" : ""}`}>
              <img src={groups} alt="" />
              
              <span className={isMessagesPage ? "messagePage" : ""}>Your Circles</span>
            </Link>
          </div>

          <div className={`item ${location.pathname.includes("/userfeeds") ? "active" : ""}`}>
            <Link to="/userfeeds" className={`item-link ${location.pathname.includes("/userfeeds") ? "active" : ""}`}>
              <img src={pages} alt="" />
             
              <span className={isMessagesPage ? "messagePage" : ""}>Your Channels</span>
            </Link>
          </div>

          <div className={`item ${location.pathname.includes("/competitions") ? "active" : ""}`}>
            <Link to="/competitions" className={`item-link ${location.pathname.includes("/competitions") ? "active" : ""}`}>
              <img src={competiton} alt="" />              
              <span className={isMessagesPage ? "messagePage" : ""}>Contest</span>
            </Link>
          </div>

          <div className={`item ${location.pathname.includes("/saved") ? "active" : ""}`}>
            <Link to="/saved" className={`item-link ${location.pathname.includes("/saved") ? "active" : ""}`}>
              <img src={bookmark} alt="" />
              
              <span className={isMessagesPage ? "messagePage" : ""}>Archived Items</span>
             
            </Link>
          </div>

        </div>
       
      </div>
      <div>
      <div className="bottom">
                {/* <ScheduleIcon/> */}
                <h5 style={{color:"gray"}}>Joined On : {moment(currentUser.joinOn).format('MMMM Do YYYY') }</h5>
              </div>
      <div className="bottom" onClick={() => setIsModalVisible(true)}>
        
        <span style={{color:"red"}}>Logout</span>
        <img src={logoutImg} alt="" width={"25px"} />
      </div>
      </div>
      <Modal
        title="Logout Confirmation"
        visible={isModalVisible}
        onOk={handleLogout}
        onCancel={handleCancel}
        footer={[
          <button
            style={{
              backgroundColor: "#e4002b",
              color: "white",
              border: "none",
              borderRadius: "5px",
              width: "4rem",
              height: "2rem",
              fontWeight: "600",
              fontSize: "0.9rem",
            }}
            key="logout"
            type="primary"
            onClick={handleLogout}
          >
            Logout
          </button>,
        ]}
      >
        <p>Are you sure you want to logout?</p>
      </Modal>
    </div>
  );
};

export default LeftBar;
